import { BusinessFormValues } from "components/Business/BusinessForm/types";
import {
  OPEN_GENERATE_REPORTS_FROM_BUSINESS_TRANSACTIONS_TABLE,
  SUBMIT_BUSINESS_FORM,
  TOGGLE_BUSINESS_MODAL_SECTION,
} from "constants/actionTypes";

import { FormikTouched } from "formik";
import { FormikSnapshot } from "sagas/modals/util";

export interface GenerateReportsFromBusinessTransactionsTableAction {
  type: typeof OPEN_GENERATE_REPORTS_FROM_BUSINESS_TRANSACTIONS_TABLE;
  businessId: string;
  formikSnapshot: FormikSnapshot<BusinessFormValues>;
}
export function openGenerateReportsFromBusinessTransactionsTable(
  businessId: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Formik context, type requires generic modal architecture
  formikSnapshot?: FormikSnapshot<any>,
): GenerateReportsFromBusinessTransactionsTableAction {
  return {
    type: OPEN_GENERATE_REPORTS_FROM_BUSINESS_TRANSACTIONS_TABLE,
    businessId,
    formikSnapshot,
  };
}

export function toggleBusinessModalSection(section) {
  return { type: TOGGLE_BUSINESS_MODAL_SECTION, section };
}

export interface SubmitFormAction {
  type: typeof SUBMIT_BUSINESS_FORM;
  businessId: string;
  submittedValues: Partial<BusinessFormValues>;
  touched: FormikTouched<BusinessFormValues>;
}
export function submitBusinessForm(
  businessId: string,
  submittedValues: Partial<BusinessFormValues>,
  touched: FormikTouched<BusinessFormValues>,
): SubmitFormAction {
  return {
    type: SUBMIT_BUSINESS_FORM,
    businessId,
    submittedValues,
    touched,
  };
}
